import script from "./Tip.vue?vue&type=script&lang=ts&setup=true"
export * from "./Tip.vue?vue&type=script&lang=ts&setup=true"

import "./Tip.vue?vue&type=style&index=0&id=554d21d0&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-554d21d0"]])

export default __exports__